import {EventEmitter} from 'events';
import Dispatcher from '../dispatcher';
import assign from 'object-assign';

const AccessCodesStore = assign({}, EventEmitter.prototype, {

  _state: undefined,
  isLoading: false,

  _updateState(state) {
    this._state = state;
    Dispatcher.emit(Dispatcher.ACCESS_CODE_STORE_CHANGE);
  },

  get(id) {
    this._load();
    return this._state ? this._state[id] : undefined;
  },

  getAll(update) {
    this._load(update);
    return this._state || undefined;
  },

  _filterResponse(data) {

    // Widths coming back in response, can use this if we don't feel like hard coding
    let width = 60

    data.licenses.map(item => {
      item.coverURL = data.coverURL
      .replace(":isbn" , item.isbn)
      .replace(":width" , width)

      return item;
    })
    return data;
  },

  _load(update) {
    if (!this.isLoading && (update || this._state === undefined)){
      this.isLoading = true;
      Jigsaw.getAllAccessCodes(function(response){
        if (response.isSuccess()){
          this._updateState(this._filterResponse(response.data));
        }else{
          this._updateState({licenses: []});
        }
        this.isLoading = false;
      }.bind(this));
    }
  },

  init() {

  }

});

AccessCodesStore.init();
export default AccessCodesStore;



/** WEBPACK FOOTER **
 ** ./src/js/stores/access-codes-store.js
 **/